import axios from 'axios'
import {
    ReportModelConfigurationMatch,
    ReportModelConfigurationResponse,
    UserappReportModelConfigurationRequest,
    UserappReportModelConfigurationResponse
} from '@/modules/printModule/services/report-model-configuration/report-model-configuration.model'
import { AvailablePrinter } from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'

class ReportModelConfigurationService {
    async getConfiguredReportModels(
        laboratoryId: number
    ): Promise<ReportModelConfigurationResponse[]> {
        let params = {
            laboratoryId
        }
        const response = await axios.get<ReportModelConfigurationResponse[]>(
            '/configuration/reportModels',
            { params })
        return response.data
    }

    async getConfiguredPrinters(
        laboratoryId: number,
        workstation: string
    ): Promise<UserappReportModelConfigurationResponse[]> {
        const params = {
            laboratoryId,
            workstation
        }
        const response = await axios.get<UserappReportModelConfigurationResponse[]>(
            '/configuration/user/reportModelConfigurations',
            { params })
        return response.data
    }

    async saveDevicesConfiguration(
        laboratoryId: number,
        workstation: string,
        request: UserappReportModelConfigurationRequest[]
    ): Promise<UserappReportModelConfigurationResponse[]> {
        const params = {
            laboratoryId
        }
        const response = await axios.put<UserappReportModelConfigurationResponse[]>(
            `/configuration/user/workstation/${workstation}/reportModelConfigurations`,
            request,
            { params })
        return response.data
    }

    /// UTILS

    applyUserConfigurationToReportModels(
        reportModels: ReportModelConfigurationResponse[],
        reportModelsConfiguration: UserappReportModelConfigurationResponse[],
        availablePrinters: AvailablePrinter[]
    ): ReportModelConfigurationMatch[] {
        return reportModels.map(reportModel => {
            const userModelConfiguration = reportModelsConfiguration.find(reportModelConfiguration =>
                reportModelConfiguration.reportModel === reportModel.reportModel &&
                ((!reportModel.printer && !reportModelConfiguration.printerId) ||
                    (reportModel.printer?.id === reportModelConfiguration.printerId)))

            let selectedPrinter: AvailablePrinter | undefined
            if (userModelConfiguration?.encodedPrinterName) {
                selectedPrinter = availablePrinters.find(availablePrinter => availablePrinter.code === userModelConfiguration.encodedPrinterName)
            }

            return {
                // ReportModelConfigurationResponse
                ...reportModel,
                // UserappReportModelConfigurationResponse
                copies: userModelConfiguration?.copies ?? 1,
                path: userModelConfiguration?.path,
                // UserappReportModelConfigurationResponse id
                userReportModelConfigurationId: userModelConfiguration?.id,
                // AvalaiblePrinter
                selectedPrinter
            }
        })
    }
}

export const reportModelConfigurationService = new ReportModelConfigurationService()
